import { Directive, EventEmitter, Injectable, Output } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { IoEventTypes } from 'ops/common/io-event/websocket-message';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';

@Directive()
@Injectable()
export class HmiService {
    @Output() onAlarmsStatus: EventEmitter<any> = new EventEmitter();

    private socket: Socket;
    private bridge: any = null;

    constructor() {
        this.socket = io(EndPointApi.getURL(), { path: '/ioSocket' });
    }

    // public onDeviceValueResponse(): Observable<any> {
    //     return new Observable<any>((observer) => {
    //         const socketEventCallback = (data) => {
    //             observer.next(data);
    //         };

    //         this.socket.on(IoEventTypes.DEVICE_VALUES, socketEventCallback);

    //         return this._createCleanupFunction(IoEventTypes.DEVICE_VALUES, socketEventCallback);
    //     });
    // }

    public askDeviceValues() {
        if (this.socket) {
            this.socket.emit(IoEventTypes.DEVICE_VALUES, 'get');
        } else if (this.bridge) {
            this.bridge.getDeviceValues(null);
        }
    }

    public askSimulatorActive() {
        if (this.socket) {
            this.socket.emit(IoEventTypes.SIMULATOR_ACTIVE, 'get');
        }
    }

    public askFrequency() {
        if (this.socket) {
            this.socket.emit(IoEventTypes.FREQUENCY_VALUE, 'get');
        }
    }

    public onFrequencyValue() {
        return new Observable<any>((observer) => {
            const socketEventCallback = (data) => {
                if (data.activeFrequency) {
                    observer.next(data.activeFrequency);
                }
            };

            this.socket.on(IoEventTypes.FREQUENCY_VALUE, socketEventCallback);

            return this._createCleanupFunction(IoEventTypes.FREQUENCY_VALUE, socketEventCallback);
        });
    }

    public onSimulatorStart() {
        return new Observable<any>((observer) => {
            const socketEventCallback = (data) => {
                observer.next(data);
            };

            this.socket.on(IoEventTypes.SIMULATOR_ACTIVE, socketEventCallback);

            return this._createCleanupFunction(IoEventTypes.SIMULATOR_ACTIVE, socketEventCallback);
        });
    }

    _createCleanupFunction(evtName, evtFunction): () => void {
        return () => this.socket.removeListener(evtName, evtFunction);
    }

    /**
     * Init the socket and subsribe to device status and signal value change
     */
    public initSocket() {
        // alarms status
        this.socket.on(IoEventTypes.ALARMS_STATUS, (alarmsstatus) => {
            this.onAlarmsStatus.emit(alarmsstatus);
        });
    }
}
